import { useContext, useEffect, useState } from 'react';

import { useParams } from 'react-router';

import Loading from '../../../Components/Loading/Loading';
import { useApi } from '../../../Hooks/Api';
import { useToast } from '../../../Hooks/Toast';
import Master from '../../../Layouts/Master';
import Ranks from '../Components/CompetitionPorvinceRank/Ranks';
import Search from '../Components/CompetitionPorvinceRank/Search';
import { CompetitionContext } from '../Context/CompetitionContext';

const CompetitionProvinceRank = () => {
  const { id } = useParams();
  const { get, post, destroy } = useApi();
  const { success, error } = useToast();
  const [loadingSelectRank, setLoadingSelectRank] = useState(false);
  const context = useContext(CompetitionContext);
  const [loading, setLoading] = useState(true);
  const [ranks, setRanks] = useState([]);
  const [formSubmitLoading, setFormSubmitLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);

  useEffect(() => {
    const getData = async () => {
      await getCompetition();
      await getProvinces();
      await getCompetitionRank();
    };
    getData();
  }, [id]);

  const getProvinces = async () => {
    setLoading(true);
    await get(
      `/province`,
      (res) => {
        context.provinces = res.data;
      },
      (err) => {
        error('هنگام دریافت اطلاعات خطایی رخ داده است.');
        setLoading(false);
      },
    );
  };
  const getCompetition = async () => {
    setLoading(true);
    await get(
      `/competition/${id}`,
      (res) => {
        context.competition = res.data;
      },
      (err) => {
        error('هنگام دریافت اطلاعات خطایی رخ داده است.');
        setLoading(false);
      },
    );
  };

  const getCompetitionRank = async () => {
    setLoading(true);
    await get(
      `/competition/${id}/province/rank`,
      (res) => {
        const getRanks = res.data.map((rank) => {
          return {
            id: rank.id,
            rank: rank.rank,
            sport_id: rank?.sport?.id ?? 0,
            province_id: rank?.province?.id ?? 0,
            weight_id: rank?.weight?.id ?? 0,
          };
        });
        setRanks(getRanks);
        setLoading(false);
      },
      (err) => {
        error('هنگام دریافت اطلاعات خطایی رخ داده است.');
        setLoading(false);
      },
    );
  };

  const onChangeRank = async (name, index, value) => {
    const ranksCopy = await [...ranks];
    ranksCopy[index][name] = await value;
    await setRanks(ranksCopy);
  };

  const addRank = async (rank) => {
    const ranksCopy = await [...ranks];
    await ranksCopy.push(rank);
    await setRanks(ranksCopy);
    success(
      'ورزشکار با موفقیت اضافه شد لطفا اطلاعات ورزشکار را در جدول مقام ها ثبت نمایید در غیر اینصورت مقام بصورت اشتباه ثبت خواهد شد',
    );
  };

  const removerank = async (rank) => {
    setDeleteLoading(true);
    setLoadingSelectRank(true);
    const ranksCopy = [...ranks];
    let rankFind = ranksCopy?.[rank?.index];
    if (rankFind?.id != null && rankFind?.id !== undefined) {
      await destroy(
        `/competition/${id}/province/rank/${rankFind?.id}`,
        (res) => {},
        (err) => {
          error('حذف به علت خطا انجام نشد');
          setDeleteLoading(false);
          setLoadingSelectRank(false);
        },
      );
    }
    // console.log(ranksCopy.filter((r, i) => i != rank?.index));
    // await delete ranksCopy[rank.index];
    await setRanks((preveRanks) =>
      preveRanks.filter((r, i) => i != rank?.index),
    );
    // await setRanks(ranksCopy);
    success('با موفقیت حذف شد');
    setLoadingSelectRank(false);
    setDeleteLoading(false);
    setModalIsOpen(false);
  };

  const submitForm = async () => {
    if (ranks.length == 0) {
      return error('لطفا رده بندی را تکمیل نمایید');
    }
    setFormSubmitLoading(true);
    const data = {
      ranks: ranks,
      competition_id: id,
    };

    await post(
      `/competition/${id}/province/rank`,
      data,
      (res) => {
        success('رده بندی با موفقیت انجام شد');
        setFormSubmitLoading(false);
      },
      (err) => {
        error('ثبت رده بندی موفقیت آمیز نبود');
        setFormSubmitLoading(false);
      },
    );
  };

  console.log(ranks);

  return loading ? (
    <Loading />
  ) : (
    <Master>
      <div className='row'>
        <Search context={context} addRank={addRank} />
        <Ranks
          ranks={ranks}
          removeRank={removerank}
          removeLoading={deleteLoading}
          modalIsOpen={modalIsOpen}
          setModalIsOpen={setModalIsOpen}
          competition={context.competition}
          onChangeRank={onChangeRank}
        />
        <div className='col-12 d-flex flex-row justify-content-center my-4'>
          {formSubmitLoading ? (
            <button className='btn bg-persian-green f-12 text-white py-2 px-3'>
              <div
                className='spinner-border text-white spinner-border-sm mb-1'
                role='status'
              >
                <span className='sr-only'></span>
              </div>
            </button>
          ) : (
            <button
              onClick={submitForm}
              className='btn f-12 bg-persian-green text-white py-2 px-3'
            >
              ذخیره اطلاعات
            </button>
          )}
        </div>
      </div>
    </Master>
  );
};

export default CompetitionProvinceRank;
